import "../../styles/global.scss";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useState, useMemo } from "react";
import { serverUrl } from "../../helpers/utility";
import logo from "../../images/logo.png";
import { useLocation, Link } from "react-router-dom";

function ResetPassword() {
  const location = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const token = searchParams.get("token");
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  async function onSubmit(data) {
    try {
      setError(null);
      await axios.post(`${serverUrl}/auth/reset-password`, {
        token,
        password: data.password,
      });
      setSubmitted(true);
    } catch (err) {
      console.error(`ERR: reset-password submit. ${err}`);
      setError(err?.response?.data?.message || "Could not reset password. Please try again.");
    }
  }

  if (!token) {
    return (
      <Container fluid className={`no-padding no-margin container-fluid`}>
        <Row className="justify-content-center" style={{ paddingTop: 40 }}>
          <Col lg={5}>
            <Card>
              <Card.Body style={{ padding: 24 }}>
                <h3 className="h4 mb-2">Reset password</h3>
                <div className="alert alert-danger">Missing token. Please use the link in your email.</div>
                <Link to="/forgot-password">Request a new link</Link>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container fluid className={`no-padding no-margin container-fluid`}>
      <Row className="justify-content-center" style={{ paddingTop: 40 }}>
        <Col lg={5}>
          <Card>
            <Card.Body style={{ padding: 24 }}>
              <div style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}>
                <img src={logo} style={{ height: 32 }} />
              </div>
              {submitted ? null : <h3 className="h4 mb-2 text-center">Set a new password</h3>}
              {submitted ? (
                <div className="text-center">
                  <div className="alert alert-success mt-3 text-center">
                    Password updated. You can now login.
                    <br />
                  </div>
                  <Link
                    className="text-primary font-weight-bold text-decoration-underline"
                    to="/login"
                  >
                    Go to login
                  </Link>
                </div>
              ) : (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <label>New password</label>
                  <input
                    {...register("password", { required: true, minLength: 8 })}
                    className="form-control"
                    type="password"
                    autoFocus
                    required
                  />
                  {errors.password ? (
                    <div className="text-danger mt-1">Password must be at least 8 characters</div>
                  ) : null}

                  <label className="mt-3">Confirm password</label>
                  <input
                    {...register("confirmPassword", {
                      required: true,
                      validate: (value) => value === watch("password"),
                    })}
                    className="form-control"
                    type="password"
                    required
                  />
                  {errors.confirmPassword ? (
                    <div className="text-danger mt-1">Passwords must match</div>
                  ) : null}

                  {error ? <div className="text-danger mt-3">{error}</div> : null}

                  <input
                    className="form-control btn btn-primary mt-3"
                    type="submit"
                    value={`UPDATE PASSWORD`}
                  />
                </form>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ResetPassword;

